import { UniqueIdentifier } from '@dnd-kit/core';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  IContractFormikStatus,
  IContractTemplateForm,
} from 'services/templates/types';
import { generateFormikNames } from 'utils/dnd/dndUtilities';

export const useFormikContractHelpers = () => {
  const { status, ...formikContext } =
    useFormikContext<IContractTemplateForm>();
  const formikStatus: IContractFormikStatus = status;
  const { t } = useTranslation();

  const detailId = formikContext.values.sideMenu?.detail?.id ?? '';

  const names = generateFormikNames(formikContext.values.items);

  const itemName = `${formikStatus.namePrefix}${names[detailId]}`;
  const itemNameById = (id: UniqueIdentifier) =>
    `${formikStatus.namePrefix}${names[id]}`;

  const detailName = 'sideMenu.detail';

  const setItemValue = <T>(suffix: string, value: T) => {
    formikContext.setFieldValue(`${itemName}.${suffix}`, value);

  };
  const setDetailValue = <T>(suffix: string, value: T) => {
    formikContext.setFieldValue(`${detailName}.${suffix}`, value);
  };

  const setItemAndDetailValue = <T>(suffix: string, value: T) => {
    setItemValue<T>(suffix, value);
    setDetailValue<T>(suffix, value);
  };

  return {
    ...formikContext,
    ...formikStatus,
    detailId,
    names,
    itemName,
    detailName,
    setItemValue,
    setDetailValue,
    setItemAndDetailValue,
    itemNameById,
  };
};
